import { render, staticRenderFns } from "./CalendarCourseItemComponent.vue?vue&type=template&id=02c9a523&scoped=true"
import script from "./CalendarCourseItemComponent.vue?vue&type=script&lang=ts"
export * from "./CalendarCourseItemComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c9a523",
  null
  
)

export default component.exports